import React, { useEffect } from 'react';
import { Row, Col, Typography } from 'antd';
import { HomePageHeader } from './HomePageHeader';
import { HeaderLinks } from '../shared/admin/HeaderLinks';
import { HomePageBody } from './HomePageBody';
import analytics, { EventType } from '../analytics';
import { useTranslation } from '../../i18n/useTranslation';
import { BreadcrumbContextType, useBreadcrumbContext } from '../search/context/BreadcrumbContext';
import { BreadcrumbItem } from '../search/utils/breadcrumbsUtilService';

export const HomePage = () => {
    const { breadcrumbArray, setBreadcrumbArray }: BreadcrumbContextType = useBreadcrumbContext();

    useEffect(() => {
        analytics.event({ type: EventType.HomePageViewEvent });
        setBreadcrumbArray(breadcrumbArray.length > 0 ? [breadcrumbArray[0] as BreadcrumbItem] : []);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { t } = useTranslation();
    return (
        <>
            <Row wrap={false} className="f-page-header">
                <Col flex="auto">
                    <Typography.Title className="f-page-heading">{t('Enterprise Data Catalog')}</Typography.Title>
                </Col>
                <Col flex="none">
                    <HeaderLinks />
                </Col>
            </Row>
            <div className="f-page-content">
                <HomePageHeader />
                <HomePageBody />
            </div>
        </>
    );
};
